<template>
	<div>
		<div v-if="loadingMetas">
			<preloader></preloader>
		</div>
		<h3 class="text-muted" v-if="vendedorMetas.data.length>0 && route == 'index'">
			<i class="material-icons">flag</i> Metas
		</h3>
		<button type="button" class="btn btn-success" v-on:click="addMeta()" v-if="route=='index'">
			<i class="material-icons">add</i> Agregar
		</button>
		<div v-if="route=='index'">
			<div :class="{'table-responsive':true, 'position-relative':loadingMetas}" v-if="vendedorMetas.data.length>0">
				<div class="table-loading" v-if="loadingMetas">
					<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
						<span class="sr-only">Cargando...</span>
					</div>
					<h5 class="m-0">Cargando..</h5>
				</div>
				<table class="table table-borderless table-hover table-striped table-sm">
					<thead>
						<tr>
							<th>Código</th>
							<th>Año</th>
							<th>Mes</th>
							<th>Producto</th>
							<th>Monetario</th>
							<th>Oportunidades</th>
							<th>Cantidad Producto</th>
							<th></th>
						</tr>
						<tr>
							<td colspan="8" class="p-1">
								<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
									Metas ({{vendedorMetas.total}})
								</div>
							</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="meta in vendedorMetas.data" class="cursor-pointer" v-on:click.prevent="showMeta(meta)">
							<th>{{meta.CODIGO_META}}</th>
							<th>{{meta.ANIO}}</th>
							<th>{{meta.MES}}</th>
							<th>{{meta.producto ? meta.producto.DESCRIPCION_PRODUCTO : ''}}</th>
							<th class="text-right">{{money(meta.META_MONETARIO, true)}}</th>
							<th class="text-right">{{meta.META_OPORTUNIDADES}}</th>
							<th class="text-right">{{meta.META_CANTIDAD}}</th>
							<td class="text-right">
								<div class="btn-group text-right">
									<a
									href="#"
									class="text-muted ml-2 p-1"
									v-tooltip="'Eliminar meta'"
									v-on:click.prevent.stop="deleteMeta(meta.CODIGO_META)">
										<i class="material-icons">delete</i>
									</a>

									<a
									href="#"
									class="text-muted ml-2 p-1"
									v-tooltip="'Editar meta'"
									v-on:click.prevent.stop="editMeta(meta)">
										<i class="material-icons">edit</i>
									</a>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else>
				<empty icon="hourglass_empty" title="No hay información." description="No hay información relacionada a las metas.">
				</empty>
			</div>
			<paginacion
				:pagination="vendedorMetas"
				@paginate="getMetas()"
				:offset="4">
			</paginacion>
		</div>
		<div v-else>
			<h3 v-if="route=='create'">
				<i class="material-icons">add</i>
				Agregar meta
			</h3>
			<h3 v-if="route=='edit'">
				<i class="material-icons">edit</i>
				Editar meta
			</h3>
			<h3 v-if="route=='show'">
				<i class="material-icons">search</i>
				Ver meta
			</h3>

			<div class="row justify-content-center">
				<div class="col-md-4">
					<div class="form-row">
						<div class="col-md-12 mb-3">
							<div class="d-flex justify-content-between">
								<label>Producto:</label>
								<div class="custom-control custom-checkbox" v-if="route=='create'">
									<input type="checkbox" class="custom-control-input" id="todos" v-model="meta.todos">
									<label class="custom-control-label" for="todos">Todos</label>
								</div>
							</div>
							<div v-if="!meta.todos">
								<catalogo-productos v-model="meta.codigo_producto" v-if="route!='show'"></catalogo-productos>
								<p v-else>{{meta.producto ? meta.producto.DESCRIPCION_PRODUCTO : ''}}</p>
							</div>
							<div v-if="errors && errors.codigo_producto" class="text-danger">
		                        {{ errors.codigo_producto[0] }}
		                    </div>
						</div>

						<div class="col-md-12 mb-3" v-if="!meta.anual">
							<label>Mes:</label>
							<select2 v-model="meta.mes" v-if="route!='show'">
								<option value="01">Enero</option>
								<option value="02">Febrero</option>
								<option value="03">Marzo</option>
								<option value="04">Abril</option>
								<option value="05">Mayo</option>
								<option value="06">Junio</option>
								<option value="07">Julio</option>
								<option value="08">Agosto</option>
								<option value="09">Septiembre</option>
								<option value="10">Octubre</option>
								<option value="11">Noviembre</option>
								<option value="12">Diciembre</option>
							</select2>
							<p v-else>{{meta.mes | nameMonth}}</p>
							<div v-if="errors && errors.mes" class="text-danger">
		                        {{ errors.mes[0] }}
		                    </div>
						</div>

						<div class="col-md-12 mb-3" v-if="!meta.anual">
							<label>Año:</label>
							<input type="number" class="form-control form-control-sm" minlength="4" maxlength="4" v-model="meta.anio" v-if="route!='show'">
							<p v-else>{{meta.anio}}</p>
							<div v-if="errors && errors.anio" class="text-danger">
		                        {{ errors.anio[0] }}
		                    </div>
						</div>

						<div class="col-md-12 mb-3" v-if="route=='create'">
							<div class="custom-control custom-switch">
								<input type="checkbox" class="custom-control-input" id="anual" v-model="meta.anual">
								<label class="custom-control-label cursor-help" for="anual" v-tooltip="'Carga el presupuesto en los 12 meses del año actual'">
									¿Cargar metas anual?
								</label>
							</div>
							<span v-if="errors && errors.anual" class="text-danger">
								{{errors.anual[0]}}
							</span>
						</div>
					</div>	
				</div>
				<div class="col-md-4">
					<div class="form-row">
						<div class="col-md-12 mb-3">
							<div class="card bg-primary text-white">
								<div class="card-body">
									<h5>
										<i class="material-icons">attach_money</i>
										Meta monetario:
									</h5>
									<decimal v-model="meta.meta_monetario" v-if="route!='show'"></decimal>
									<p v-else>{{money(meta.meta_monetario, true)}}</p>
								</div>
							</div>
							<div v-if="errors && errors.meta_monetario" class="text-danger">
		                        {{ errors.meta_monetario[0] }}
		                    </div>
						</div>

						<div class="col-md-12 mb-3">
							<div class="card bg-info text-white">
								<div class="card-body">
									<h5>
										<i class="material-icons">shop_two</i>
										Meta oportunidades:
									</h5>
									<integer v-model="meta.meta_oportunidad" v-if="route!='show'"></integer>
									<p v-else>{{money(meta.meta_oportunidad, true)}}</p>
								</div>
							</div>
							<div v-if="errors && errors.meta_oportunidad" class="text-danger">
		                        {{ errors.meta_oportunidad[0] }}
		                    </div>
						</div>

						<div class="col-md-12 mb-3">
							<div class="card bg-success text-white">
								<div class="card-body">
									<h5>
										<i class="material-icons">exposure_plus_1</i>
										Meta cantidad producto:
									</h5>
									<integer v-model="meta.meta_cantidad" v-if="route!='show'"></integer>
									<p v-else>{{money(meta.meta_oportunidad, true)}}</p>
								</div>
							</div>
							<div v-if="errors && errors.meta_oportunidad" class="text-danger">
		                        {{ errors.meta_oportunidad[0] }}
		                    </div>
						</div>
					</div>
				</div>
			</div>
			<div class="text-right">
				<button type="button" class="btn btn-success" v-if="route=='create'" v-on:click="storeMeta()">
					Agregar meta
				</button>
				<button type="button" class="btn btn-info" v-if="route=='edit'" v-on:click="updateMeta()">
					Actualizar meta
				</button>
				<button type="button" class="btn btn-light" v-on:click="cancelAction()">
					Cancelar
				</button>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['vendedor'],

		data(){
			return {
				vendedorMetas: {
		            total: 0,
		            per_page: '',
		            data: [],
		            from: 1,
		            to: 0,
		            current_page: 1
		        },
		        loadingMetas: false,
				meta: {
					codigo: '',
					codigo_vendedor: '',
					codigo_producto: '',
					mes: '',
					anio: '',
					meta_monetario: '',
					meta_oportunidad: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					anual: false,
					todos: false,
					producto: {},
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					},
				},
				errors: {},
				route: 'index'
			}
		},

		mounted() {
			this.getMetas()
		},

		methods: {
			getMetas: function(validatePage = false){
				this.loadingMetas = true
				if (validatePage) {
					this.vendedorMetas.current_page = 1
				}

				axios.get(`api/vendedores/${this.codigoVendedor}/metas`,{
					params: {
						page: this.vendedorMetas.current_page,
						per_page: this.vendedorMetas.per_page
					}
				})
				.then(response => {
					this.vendedorMetas = response.data
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loadingMetas = false
				})
			},

			addMeta(){
				this.route = 'create'
				this.cleanFields()
			},

			storeMeta(){
				this.loadingMetas = true
				
				axios.post(`api/vendedores/${this.codigoVendedor}/metas`, this.meta)
				.then(response => {
					this.getMetas()
					this.route = 'index'
					this.cleanFields()
					this.$toasted.show('Meta agregada')
				}).catch(error => {
					console.log(error.response)
					if (error.response.status == 422) {
						this.errors = error.response.data.errors
						this.$toasted.show('Existen errores en los campos')
					}else{
						this.$toasted.show('Error al agregar metas')
					}
				}).then(()=>{
					this.loadingMetas = false
				})
			},

			editMeta: function(data){
				this.route = 'edit'
				this.meta.codigo = data.CODIGO_META
				this.meta.codigo_vendedor = data.CODIGO_VENDEDOR
				this.meta.codigo_producto = data.CODIGO_PRODUCTO
				this.meta.mes = data.MES
				this.meta.anio = data.ANIO
				this.meta.anio = data.ANIO
				this.meta.anual = false
				this.meta.todos = false
				this.meta.meta_monetario = data.META_MONETARIO
				this.meta.meta_oportunidad = data.META_OPORTUNIDADES
				this.meta.meta_cantidad = data.META_CANTIDAD
				this.meta.producto = data.producto
				this.errors = {}
			},

			updateMeta(){
				if (!this.meta.codigo) {
					return
				}
				this.loadingMetas = true
				
				axios.put(`api/vendedores/${this.codigoVendedor}/metas/${this.meta.codigo}`, this.meta)
				.then(response => {
					this.getMetas()
					this.route = 'index'
					this.cleanFields()
					this.$toasted.show('Meta actualizada');
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loadingMetas = false
				})
			},

			showMeta: function(data){
				this.route = 'show'
				this.meta.codigo = data.CODIGO_META
				this.meta.codigo_vendedor = data.CODIGO_VENDEDOR
				this.meta.codigo_producto = data.CODIGO_PRODUCTO
				this.meta.mes = data.MES
				this.meta.anio = data.ANIO
				this.meta.anio = data.ANIO
				this.meta.anual = false
				this.meta.todos = false
				this.meta.meta_monetario = data.META_MONETARIO
				this.meta.meta_oportunidad = data.META_OPORTUNIDADES
				this.meta.meta_cantidad = data.META_CANTIDAD
				this.meta.producto = data.producto
				this.errors = {}
			},

			deleteMeta: function(codigo){
				var url = `api/vendedores/${this.codigoVendedor}/metas/${codigo}`;
				var modules = this;

				$.confirm({
			        title: '¿Estás seguro?',
			        content: '¡Ya no podrás recuperar esta información!',
			        theme: 'supervan', // 'material', 'bootstrap'
			        buttons: {
			            Confirmar: function () {
			                axios.delete(url)
			                    .then(response => {
			                    	modules.getMetas();
			                        modules.$toasted.show('Eliminado');
			                    })
			                    .catch(error => {
			                        modules.$toasted.show('Error al Eliminar');
			                        console.log(error);
			                        console.log(error.response);
			                    });
			            },
			            Cancelar: function () {
			            },
			        }
			    });
			},

			cancelAction: function(){
				this.route = 'index'
				this.cleanFields()
			},

			cleanFields: function(){
				this.meta.codigo = ''
				this.meta.codigo_vendedor = ''
				this.meta.codigo_producto = ''
				this.meta.mes = ''
				this.meta.anio = ''
				this.meta.anual = false
				this.meta.todos = false
				this.meta.meta_monetario = ''
				this.meta.meta_oportunidad = ''
				this.meta.fecha_actualizacion = ''
				this.meta.creado_desde = ''
				this.meta.actualizado_desde = ''
				this.meta.creado_por.codigo = ''
				this.meta.creado_por.nombre = ''
				this.meta.actualizado_por.codigo = ''
				this.meta.actualizado_por.nombre = ''
				this.meta.producto = {}
				this.errors = {}
			}
		},

		computed: {
			requerimientoFilter: function(){
				return this.requerimiento
			},

			codigoVendedor: function(){
				return this.vendedor
			}

		},

		watch: {
			requerimientoFilter: function(val, oldVal){
				if (oldVal == val) {
					return
				}
				this.getMetas(true)
			}
		},

		filters: {
			nameMonth: function(value){
				var months = [
					'Enero',
					'Febrero',
					'Marzo',
					'Abril',
					'Mayo',
					'Junio',
					'Julio',
					'Agosto',
					'Septiembre',
					'Octubre',
					'Noviembre',
					'Diciembre'
				]

				if (value <= 0 || value >= 12) {return ''}

				return months[value-1]
			}
		}
	}
</script>